var script = document.createElement('script')
script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBRXkJMAMRdcqSH_M-FkMlqES8_y_KJXuo&callback=initMap&language=el&region=GR'
script.defer = true
script.async = true

window.initMap = function () {
  const addresses = window.jsonStores

  let map = new google.maps.Map(document.getElementById('mapStores'), {
    center: {
      lat: 39.0724068,
      lng: 21.8305935
    },
    zoom: 7
  })

  let geocoder = new google.maps.Geocoder()

  addresses.forEach(function (address) {
    let contentString = '<div>' +
      '<h5 class="infoWindowHeading">' + address.city + '</h5>' +
      '<div>' +
      '<p><strong>Διεύθυνση:</strong> ' + address.address + '</p>' +
      '<p><strong>Ωρες Λειτουργίας:</strong> ' + address.openingHours + '</p>' +
      '<p><strong>Τηλ:</strong> ' + address.phone + '</p>' +
      '</div>' + '</div>'
    let infowindow = new google.maps.InfoWindow({
      content: contentString
    })

    geocoder.geocode({ 'address': address.address }, function (results, status) {
      if (status == 'OK') {
        let marker = new google.maps.Marker({
          map: map,
          position: results[0].geometry.location,
          title: address.city
        })
        marker.addListener('click', function () {
          infowindow.open(map, marker)
        })
      }
    })
  })
}

// Append the 'script' element to 'head'
document.head.appendChild(script)
